const LOADER_ID = 'usercentrics-cmp';

interface UsercentricsCmp {
  changeLanguage?: (language: string) => Promise<void>;
}

// Must run before initGoogleTagManager: both scripts are injected with async=false so the browser executes them in insertion order.
export function initUsercentrics(settingsId: string, language: string) {
  if (document.getElementById(LOADER_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = LOADER_ID;
  script.src = 'https://web.cmp.usercentrics.eu/ui/loader.js';
  script.async = false;
  script.setAttribute('data-settings-id', settingsId);
  script.setAttribute('data-language', language);
  document.head.insertBefore(script, document.head.firstChild);
}

export function changeUsercentricsLanguage(language: string) {
  const script = document.getElementById(LOADER_ID);

  if (!script) {
    return;
  }

  // Covers a language switch that happens before the loader has finished executing.
  script.setAttribute('data-language', language);
  ((window as any).__ucCmp as UsercentricsCmp | undefined)?.changeLanguage?.(language);
}
